/*
 * @Author: LZH
 * @Date: 2023-04-03 10:43:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-04-11 17:56:10
 * @Description:
 */
export default {
  Problem_feedback: 'Veuillez saisir un problème et une suggestion',
  contact_information: 'Veuillez saisir les coordonnées',
  contact_information_the: 'Veuillez saisir les coordonnées',
  import: 'saisir',
  Please_enter: 'Veuillez entrer',
  Old_password: 'ancien mot de passe',
  New_password: 'nouveau mot de passe',
  Required: 'Requis',
  Enteranewpassword: 'Entrez un nouveau mot de passe',
  Confirm_new_password: 'Confirmer le nouveau mot de passe',
  mobile: 'Numéro de téléphone portable',
  QQ: 'Numéro QQ',
  postbox: 'boîte aux lettres',
  contact_you: 'Pratique pour vous contacter',
  question: 'Veuillez saisir votre question',
  Characters_up: '6 à 16 caractères',
  address: 'Veuillez saisir une adresse détaillée',
  renewal_contact: 'Veuillez saisir les coordonnées de renouvellement',
  ple_contact_name: 'Veuillez saisir le nom du contact',
  Please_enter_withdrawal: 'Veuillez saisir le retrait',
  Number_of_cards: 'Nombre de cartes',
  Pleasechooseanagent: 'Veuillez choisir un agent',
  Pleaseenterthequantity: 'Veuillez saisir la quantité',
  Pleaseentertheuserprefixnickname: "Veuillez saisir le surnom du préfixe de l'utilisateur (2 à 26 chiffres)",
  PleaseEnterImei: 'Veuillez saisir le numéro IMEI à 15 chiffres',
  Remarkswithin: 'Remarques : dans les 100 mots',
  Pleaseselectaunit: 'Veuillez sélectionner une entreprise',
  Pleaseselectagrouptojoin: 'Veuillez sélectionner un groupe à rejoindre',
  Pleaseentertheunitname: "Veuillez saisir le nom de l'entreprise",
  companynamerequired: '(obligatoire : 4 à 20 caractères lettres chiffres)',
  Pleaseenterloginaccount: 'Veuillez entrer le compte de connexion',
  loginaccountrequired: '(obligatoire : 6 à 20 lettres et chiffres)',
  Pleaseenteryourpassword: 'Veuillez entrer votre mot de passe de connexion',
  loginpasswordrequired: '(obligatoire : 6 à 16 chiffres)',
  Pleaseenteracontactname: 'Veuillez saisir le nom du contact',
  contactnamerequired: '(obligatoire : 2 à 20 caractères lettres chiffres)',
  Pleaseenteraprefixname: 'Veuillez saisir le nom du préfixe',
  prefixnamerequired: '(obligatoire : 2 à 12 caractères lettres chiffres)',
  Contactnamerequired20: 'Nom du contact (obligatoire : 2 à 20 caractères)',
  mobilephonenumber: 'Numéro de téléphone portable (facultatif)',
  Enteremailaddress: "Entrez l'adresse e-mail (facultatif)",
  Enterdetailedaddress: "Entrez l'adresse détaillée (facultatif)",
  Pleaseenteragroupname: 'Veuillez saisir un nom de groupe (obligatoire : 2 à 15 caractères)',
  Groupnamerequired: 'Nom du groupe (obligatoire : 2 à 15 caractères)',
  Pleasetypeyourphonenumber: 'Veuillez entrer votre numéro de téléphone',
  Pleaseinputtheemailaddress: "Veuillez saisir l'adresse e-mail",
  Pleaseenterthemailingaddress: "Veuillez saisir l'adresse postale",
  RequiredPleaseenterusernickname: "(Obligatoire) Veuillez saisir le nom d'utilisateur",
  Pleasemobilephonenumber: '(Facultatif) Veuillez saisir votre numéro de téléphone portable',
  PleaseentertheoriginalIMEInumber: "Veuillez saisir le numéro IMEI d'origine à 15 chiffres",
  PleaseenterthenewIMEInumber: 'Veuillez saisir le nouveau numéro IMEI à 15 chiffres',
  Pleaseenteraverificationcode: 'Veuillez saisir un code de vérification à 4 chiffres',
  Pleaseenterthemobilephonenumbertobebound: 'Veuillez saisir le numéro de téléphone portable à lier',
  PleaseenteragroupnameTow: 'Veuillez saisir un nom de groupe',
  Pleaseenterusername: "Veuillez entrer le nom d'utilisateur",
  Fencenamerequired: 'Nom de la clôture (obligatoire : 1 à 15 caractères)',
  Pleaseenterthefencename: 'Veuillez saisir le nom de la clôture',
  Pleaseselectatime: 'Veuillez sélectionner une heure',

  please_rest_password: "Bonjour, pour la sécurité de votre compte, il est recommandé de réinitialiser d'abord le mot de passe de connexion.",
  TheLastGroupUnderTheUnitCannotBeDeleted: "Le dernier groupe sous l'unité ne peut pas être supprimé.",
}
